/**
 * Minimal layout for public permalink pages – shareable, no login required.
 * Header: site name + Login (or Dashboard if logged in).
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './PublicLayout.css';

export default function PublicLayout({ children, title }) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="public-layout">
      <header className="public-layout-header">
        <Link to="/" className="public-layout-brand" aria-label="GradedPlay - Home">
          <img src="/design/logos/gradedplay-high-resolution-logo-tranparent.png" alt="" className="public-layout-logo" aria-hidden />
        </Link>
        <nav className="public-layout-nav">
          {currentUser ? (
            <button type="button" onClick={() => navigate('/dashboard')} className="btn-secondary btn-small">
              Dashboard
            </button>
          ) : (
            <Link to="/" className="public-layout-login">Log in</Link>
          )}
        </nav>
      </header>
      {title && (
        <h1 className="public-layout-title">{title}</h1>
      )}
      <main className="public-layout-main">
        {children}
      </main>
    </div>
  );
}
